import { registerTab } from "lib/@components/tabs"
import { SkillsSummaries } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/skills/skills-summaries"

registerTab({
    tab: "assetTaskPerspective",
    id: "skill",
    title: "Skills",
    content: <SkillsSummaries $lazy />,
})
